module.exports = __webpack_public_path__ + "img/shot_img122402.b68b85ce.gif";